<template>
  <a-row type="flex" justify="center">
    <h1>404 NotFound</h1>
  </a-row>
</template>
